import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import { Characteristic } from 'enums/characteristic';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const BaseIngredientCaloriesCard = ({
	state,
	handlers,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	const getLabel = (): string => {
		if (state.characteristic == Characteristic.Fluid) {
			return `${t('_general:CALORIES')} (${t('measurments:CAL_PER_100_MILLILITERS')})`;
		} else {
			return `${t('_general:CALORIES')} (${t('measurments:CAL_PER_100_GRAMMS')})`;
		}
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-calories-card"
			title={t('_general:CALORIES')}
			content={
				<>
					<div className="card-body">
						<label>{getLabel()}</label>
						<RoundedInput
							error-key="Calories"
							disabled={!isBaseIngredientEditor}
							handleChange={handlers.setCalories}
							name="calories"
							value={state.calories}
						/>
					</div>
				</>
			}
		/>
	);
};
